import { HStack, XButton, XDiv, XImage } from "IZOX/_X";
import { Signizo } from "IZOX/BLOCKS/Labs";
import { Accessor, ColorX, GFunc, LogicX, ZValidate } from "IZOX/STATIC";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { FaFileSignature } from "react-icons/fa6";

/**
 * @typedef {import("IZOX/STATIC/ZValidate").fvalidate} fvalidate
 * 
 * @typedef {Object} qfsignatureaddOns
 * @property {({doc, field, addOns}) => Boolean} isError
 * 
 * @typedef {qfsignatureaddOns} qfsignatureparams
 * 
 * @param {qfsignatureparams} param0 
 */
function QFSignature({
  name = undefined,
  label = undefined,
  _onChange = null,
  _onSetDefault = null,
  defaultValue = undefined,
  formValue = {},
  round = 5,
  bColor = ColorX.CSS("greyOut"),
  error_bColor = ColorX.CSS("Error"),
  disabled_bgColor = ColorX.CSS("bgGreyOut"),
  isError = undefined,
  addOns = undefined,
  updateVia = undefined, 
  updateField = undefined,
  forceUpdateField = undefined,
  performanceBoost = undefined,
  validators = [],
  ...others
}){

  useEffect(() => {
    if(defaultValue) {
      _onSetDefault?.(name, defaultValue);
      setValue(defaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue]);

  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    let _value = Accessor.Get(formValue, name);
    setValue(_value);
  }, [formValue, name]);

  let { height, readOnly } = others;
  let _error = false;
  if(isError){
    _error = _error || isError({doc: formValue, field: value, addOns});
  }
  if(!_.isEmpty(validators)){
    _error = _error || !ZValidate.Check(value, validators);
  }

  const _onConfirm = (base64) => {
    _onChange?.(name, base64);
    GFunc.CloseBackdrop();
  };

  const openPreview = (e) => {
    e.preventDefault();
    GFunc.Backdrop(() => {
      return (
        <XDiv width={500} height={250} round={10}>
          {renderSignature()}
        </XDiv>
      );
    }, {}, true, false);
    return;
  };

  const openSignature = (e) => {
    if(readOnly) {
      openPreview(e);
      return;
    }
    GFunc.Backdrop(() => {
      return (
        <Signizo
          onCancel={() => GFunc.CloseBackdrop()}
          onConfirm={_onConfirm}
          />
      );
    }, {}, false, false);
  };

  function renderSignBtn(){
    return (
      <FaFileSignature size={height * 0.6} color={ColorX.DayNight({day: "cmBlue", night: "dmWhite"})}/>
    );
  }

  function renderSignature(){
    if(value){
      return (
        <XImage source={value} alt="" fullWidth fullHeight bgColor={ColorX.CSS("pureWhite")}/>
      );
    }
    return (
      <HStack fullWidth fullHeight>
        {renderSignBtn()}
      </HStack>
    );
  }
  
  return (
    <XButton onPress={openSignature} onMiddleClick={openPreview} bW={1} fullWidth padding={0}
      bColor={!readOnly && _error ? error_bColor : bColor} round={round}
      height={height ?? 100}>
      <HStack>
        {renderSignature()}
      </HStack>
    </XButton>
  );

}

export default React.memo(QFSignature, (prevProps, nextProps) => {
  let propIdentical = Accessor.IsIdentical(nextProps, prevProps);
  if(propIdentical){ return true; }

  if((prevProps?.options?.length ?? 0) !== (nextProps?.options?.length ?? 0)){
    return false;
  }
  
  let {updateVia, updateField, forceUpdateField, performanceBoost, name} = nextProps ?? {};

  if(updateVia !== "update") return false;

  if(performanceBoost){
    if(name.includes(updateField)){
        return false;
      }

    if(forceUpdateField?.length > 0 && LogicX.includesOneOf(name, forceUpdateField)){
      return false;
    }

    return true;
  }
  
  return false;
  
});;